import { restApi } from '../../api';
import {
  FindOrderCollectionsListOutput,
  FindOrderCollectionsListParams,
} from './collections.types';

const PATH = 'collections';

export const findOrderCollectionsList = (params: FindOrderCollectionsListParams) =>
  restApi.get<FindOrderCollectionsListOutput>(`${PATH}/orders`, params);

export const findCollectionsList = (params: FindOrderCollectionsListParams) =>
  restApi.get<FindOrderCollectionsListOutput>(PATH, params);
